import script from "./review-form.vue?vue&type=script&setup=true&lang=js"
export * from "./review-form.vue?vue&type=script&setup=true&lang=js"

import "./review-form.vue?vue&type=style&index=0&id=6d11a948&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d11a948"]])

export default __exports__